module.exports = __webpack_public_path__ + "static/media/smog.f2372317.svg";